import { Button, Box, Link, useTheme } from "@mui/material";
import { sxStyles } from "./AppointmentCardFooterSingleBtn.styles";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { PATHS } from "lib/routing/paths/paths";
import { AppointmentCardFooterSingleBtnProps } from "./AppointmentCardFooterSingleBtn.types";
import { logEventToGoogleAnalytics } from "lib/util/GoogleAnalyticsUtil/logEvent";
import { EVENTS } from "lib/util/GoogleAnalyticsUtil/events";

const AppointmentCardFooterSingleBtn = ({
  btnText,
  appointment,
  onSelect,
}: AppointmentCardFooterSingleBtnProps) => {
  const theme = useTheme();
  const classes = sxStyles(theme);
  const navigate = useNavigate();

  const { type, canMake, institutionCode } = appointment;

  return (
    <>
      {/* Online form submission is disabled for JCH only for both missed and open appointments*/}
      {!canMake ? (
        institutionCode === "JCH" ? null : (
          <Box display="flex" ml={1} mr={1} mb={1}>
            <Link
              component={RouterLink}
              to={
                type === "missed"
                  ? PATHS.APPOINTMENT_MISSED_FORM.path
                  : PATHS.APPOINTMENT_OPEN_FORM.path
              }
              onClick={() => {
                onSelect(appointment);
              }}
              sx={classes.btnLink}
            >
              {"Submit a request online"}
            </Link>
          </Box>
        )
      ) : (
        <Box>
          <Button
            variant="contained"
            sx={classes.fullButton}
            onClick={() => {
              onSelect(appointment);

              if (type === "missed") {
                logEventToGoogleAnalytics(EVENTS.CLICK_APPT_REBOOK_APPT);
                navigate(PATHS.APPOINTMENT_MISSED_FORM.path);
              }
              if (type === "open") {
                logEventToGoogleAnalytics(EVENTS.CLICK_APPT_BOOK_NEXT_APPT);
                navigate(PATHS.APPOINTMENT_OPEN_FORM.path);
              }
            }}
          >
            {btnText}
          </Button>
        </Box>
      )}
    </>
  );
};

export default AppointmentCardFooterSingleBtn;
